export const PRODUCT_KEYS = {
    base: 'products',
    all: ['products'],
    list: ['products', 'list'],
    detail: (id: string) => ['products', 'detail', id],
    clients: (id: string) => ['products', 'clients', id]
} as const;
